import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { useCelebrateStafferPetAward } from "@/hooks/useStafferPets";
import { guacHttpClient } from "@/lib/http";
import {
  CandidacyPlacement,
  HttpResponse,
  UpdateCandidacyPlacementRequest,
} from "@/types";

export function useUpdatePlacement() {
  const celebrateStafferPetAward = useCelebrateStafferPetAward();
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      id,
      updatePlacementRequest,
    }: {
      id: number;
      updatePlacementRequest: UpdateCandidacyPlacementRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/placements/${id.toString()}`;
      const res = await guacHttpClient.patch<
        CandidacyPlacement,
        HttpResponse<CandidacyPlacement>,
        UpdateCandidacyPlacementRequest
      >(path, updatePlacementRequest);

      return res.data;
    },
    onSuccess: (placement) => {
      // A placement coin, when guac awarded one for this update.
      celebrateStafferPetAward(placement.stafferPetAward);
    },
  });

  return mutation;
}
